export default __webpack_public_path__ + "static/media/seance.46c328a0.png";